import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SHOW_SEARCH_INPUT_LABEL, AUTOCOMPLETE, ERRORMESSAGE } from './search.enum';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {
  formElement!: FormGroup;
  inputNgModelNojs: string = '';
  hasIcon = true;
  inputText = '';
  inputText1 = '';
  inputText2 = '';
  inputText3 = '';
  inputText9 = '';
  hasExternalButton = true;
  public searchInputLabelEnglish = SHOW_SEARCH_INPUT_LABEL.english;
  public searchInputLabelSpanish = SHOW_SEARCH_INPUT_LABEL.spanish;
  public searchInputLabelHindi = SHOW_SEARCH_INPUT_LABEL.hindi;
  public autoComplete = AUTOCOMPLETE;
  public errorMessageEnglish = ERRORMESSAGE.errorEnglish;
  public errorMessageHindi = ERRORMESSAGE.errorHindi;
  public errorMessageSpanish = ERRORMESSAGE.errorSpanish;

  constructor(
    private formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.formElement = this.formBuilder.group({
      inputVal: [''],
      inputValtwo: [''],
      inputValthree: [''],
      nojsControl: ['']
    });

    this._activatedRoute.queryParams.subscribe(param => {
      if (param['noJsInput']) {
        this.inputNgModelNojs = param['noJsInput'];
      }    
      if(param.inputId === 'searchInput' && param.searchText){
        this.inputText = param.searchText;
        this.formElement.patchValue({
          inputVal: param.searchText
        });
      } 
      if(param.inputId === 'searchInput1' && param.searchText1){
        this.inputText1 = param.searchText1;
        this.formElement.patchValue({
          inputValtwo: param.searchText1
        });
      }
      if(param.inputId === 'searchInput2' && param.searchText2){
        this.inputText2 = param.searchText2;
        this.formElement.patchValue({
          inputValthree: param.searchText2
        });
      }
    });
  }

  doOnClearSearch() {
    this.inputText = "search is cleared";
  }

  onSearchSubmit(event: string) {
    // you can call Search API here
  }
}